export default "__VITE_ASSET__Fe1q3ZjE__"